import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.99997 13.8V6.59C2.99997 4.61 4.61998 2.98999 6.59998 2.98999H17.4C19.38 2.98999 21 4.61 21 6.59V13.8C21 15.78 19.38 17.4 17.4 17.4H15.95C15.71 17.4 15.48 17.49 15.31 17.66L11.99 20.98L8.66998 17.66C8.49998 17.49 8.26997 17.4 8.02997 17.4H6.57996C4.59996 17.4 2.97998 15.78 2.97998 13.8H2.99997Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7.48999V10.92",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 13.5H12.01",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgReport;
